module.exports = __webpack_public_path__ + "img/olvido2.85f56b67.svg";